import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import resize from './functions/handlerSize.ts';

import { dispatcher, store } from './redux/redux.ts';
import Root from './views/root/Root.tsx';

(async () => {
    await dispatcher({ type: 'rootInit', data: true });

    const utmItem = window.location.search
        .slice(1)
        .split('&')
        .find((item) => item.split('=')[0] === 'utm_source');
    const utmSource = utmItem ? utmItem.split('=')[1] : undefined;

    if (utmSource) {
        localStorage.setItem('utmSource', utmSource);
    }

    const invItem = window.location.search
        .slice(1)
        .split('&')
        .find((item) => item.split('=')[0] === 'inv');
    const inv = invItem ? invItem.split('=')[1] : undefined;

    if (inv) {
        localStorage.setItem('inv', inv);
    }
})();

document.addEventListener('scroll', () => {
    resize();
});

window.addEventListener('resize', () => {
    resize();
});

window.scrollGoals = {};

document.oncontextmenu = (e) => {
    e.preventDefault();
};

resize(true);

const loads: {
    event?: boolean;
    fonts?: boolean;
} = {};

const checkLoad = () => {
    if (loads.event && loads.fonts) {
        setTimeout(() => {
            dispatcher({ type: 'windowIsLoad', data: true });
            dispatcher({ type: 'windowIsReady', data: true });

            resize(true);

            document.dispatchEvent(new CustomEvent('windowReady'));
        }, 10);
    }
};

document.fonts.ready.then(() => {
    setTimeout(() => {
        loads.fonts = true;

        dispatcher({ type: 'isLoadFonts', data: true });

        checkLoad();
    }, 10);
});

window.onload = () => {
    setTimeout(() => {
        dispatcher({ type: 'windowIsLoad', data: true });

        const style = document.querySelector('.initStyle');

        if (style) {
            style.remove();
        }

        loads.event = true;

        checkLoad();
    }, 10);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Provider store={store}>
        <Root />
    </Provider>,
);
